import { useMatch } from 'react-router-dom'

/**
 * Reads the current location and returns the property the user is currently viewing,
 * if they are on a /property/:id... route. Returns null fields otherwise.
 *
 * Mounted globally inside the ChatWidget — must be safe to call outside any route subtree.
 *
 * @returns `{ id }` where `id` is the property UUID from the URL, or `null` if not on a property page.
 */
export interface CurrentPropertyContext {
  id: string | null
}

export const useCurrentPropertyContext = (): CurrentPropertyContext => {
  const match = useMatch('/property/:id/*')

  return {
    id: match?.params.id ?? null,
  }
}
